module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-notice-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/company_notice"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/company_notice_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Company Notice Edit')))])])]), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Company Notice Edit')))]), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getCompanyNoticeFlg),
      expression: "getCompanyNoticeFlg"
    }],
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("全社通達タイトル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notice_title),
      expression: "notice_title"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.notice_title
    },
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": _vm._s(_vm.notice_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notice_title = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.notice_title),
      expression: "!validation.notice_title"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("全社通達内容")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notice_content),
      expression: "notice_content"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.notice_content
    },
    attrs: {
      "type": "text",
      "maxlength": "500",
      "rows": "10"
    },
    domProps: {
      "value": _vm._s(_vm.notice_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notice_content = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.notice_content.length) + "/500")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.notice_content),
      expression: "!validation.notice_content"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("通達表示開始日")]), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.releaseStatus === 0) ? _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notice_start_date),
      expression: "notice_start_date"
    }],
    attrs: {
      "placeholder": "通達表示開始日"
    },
    domProps: {
      "value": (_vm.notice_start_date)
    },
    on: {
      "input": function($event) {
        _vm.notice_start_date = $event
      }
    }
  }) : _vm._e(), (_vm.releaseStatus !== 0) ? _c('p', {
    staticClass: "disabled"
  }, [_vm._v(_vm._s(_vm.notice_start_date))]) : _vm._e(), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.notice_start_date),
      expression: "!validation.notice_start_date"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validation.notice_start_date && _vm.validationNoticeStartDate),
      expression: "validation.notice_start_date && validationNoticeStartDate"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.validationNoticeStartDate))])], 1)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("通知期間終了日")]), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.releaseStatus !== 2) ? _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notice_end_date),
      expression: "notice_end_date"
    }],
    attrs: {
      "placeholder": "通知期間終了日"
    },
    domProps: {
      "value": (_vm.notice_end_date)
    },
    on: {
      "input": function($event) {
        _vm.notice_end_date = $event
      }
    }
  }) : _vm._e(), (_vm.releaseStatus === 2) ? _c('p', {
    staticClass: "disabled"
  }, [_vm._v(_vm._s(_vm.notice_end_date))]) : _vm._e(), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validationNoticeEndDate),
      expression: "validationNoticeEndDate"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.validationNoticeEndDate))])], 1)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("メール配信有無")]), (_vm.releaseStatus === 0) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_mail_delivery),
      expression: "is_mail_delivery"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_mail_delivery) ? _vm._i(_vm.is_mail_delivery, null) > -1 : (_vm.is_mail_delivery)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.is_mail_delivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.is_mail_delivery = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.is_mail_delivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.is_mail_delivery = $$c
        }
      }
    }
  }), _c('label', [_vm._v("メール配信する")])]) : _vm._e(), (_vm.releaseStatus !== 0) ? _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.is_mail_delivery) ? _c('p', {
    staticClass: "disabled"
  }, [_vm._v("メール配信する")]) : _vm._e(), (!_vm.is_mail_delivery) ? _c('p', {
    staticClass: "disabled"
  }, [_vm._v("メール配信しない")]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info mr-5",
    class: {
      disabled: !_vm.validationAll
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3722da0e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/company-notice-edit.pug
// module id = 804
// module chunks = 1